import { AbstractEntityMapper } from '@pf/shared-services';
import {
    RequisitionCreate,
    RequisitionDto,
    RequisitionRead,
    RequisitionSearchParams,
} from '../../entities/requisition.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { RequisitionMetadataMap } from './requisition.mapping-profile';

@Injectable()
export class RequisitionMapper extends AbstractEntityMapper<
    RequisitionRead,
    RequisitionCreate,
    RequisitionDto,
    RequisitionSearchParams
> {
    constructor() {
        super(
            RequisitionDto,
            PlatformWmsMapper,
            RequisitionMetadataMap.symbols
        );
    }
}
